import React, { useEffect, useState } from "react";
import { Table, Image, Tag } from "antd";
import BreadcrumbComponent from "../../../../components/CssComponents/BreadCrumbComponents";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase-config.js";

const Transactions = () => {
  const breadcrumbItems = [{ name: "Transactions" }];
  const [transactions, setUserTransactions] = useState([]);

  // Fetch all transactions from all users
  const fetchUserTransactions = async () => {
    try {
      const snap = await getDocs(collection(db, "users"));

      let allTransactions = [];

      snap.forEach((doc) => {
        const userData = doc.data();
        if (userData?.buyItemIdsArray?.length) {
          const userTransactions = userData.buyItemIdsArray.map((tx) => ({
            ...tx,
            uid: doc.id,
          }));
          allTransactions.push(...userTransactions);
        }
      });

      // ✅ sort ascending by createdAt (fallback to updatedAt if missing)
      allTransactions.sort((a, b) => {
        const dateA =
          a.createdAt?.toDate?.() || a.updatedAt?.toDate?.() || new Date(0);
        const dateB =
          b.createdAt?.toDate?.() || b.updatedAt?.toDate?.() || new Date(0);
        return dateA - dateB; // ascending
      });

      return allTransactions;
    } catch (err) {
      console.error("Error fetching transactions:", err);
      return [];
    }
  };

  useEffect(() => {
    const loadTransactions = async () => {
      const transactions = await fetchUserTransactions();
      setUserTransactions(transactions); // set to state
    };
    loadTransactions();
  }, []);

  const columns = [
    {
      title: "Amount",
      dataIndex: "buyItemPrice",
      key: "amount",
      render: (price) => (price ? `₹ ${price}` : "N/A"),
    },
    {
      title: "Item ID",
      dataIndex: "buyItemId",
      key: "buyItemId",
    },
    {
      title: "Item Type",
      dataIndex: "buyItemType",
      key: "buyItemType",
      render: (type) => type || "N/A",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color =
          status === "approved"
            ? "green"
            : status === "pending"
            ? "orange"
            : "red";
        return <Tag color={color}>{status?.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Transaction Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date, record) => {
        const value = date?.toDate?.() || record.updatedAt?.toDate?.(); // convert Firestore Timestamp
        return value ? value.toLocaleString() : "Not Available";
      },
    },

    {
      title: "Proof",
      dataIndex: "proofUrls",
      key: "proofUrls",
      render: (urls) =>
        urls && urls.length > 0 ? (
          <div className="flex gap-2">
            {urls.map((url, index) => (
              <Image
                preview
                key={index}
                src={url}
                alt={`Proof ${index + 1}`}
                className="!h-20 !w-24 object-cover rounded"
              />
            ))}
          </div>
        ) : (
          "No Proof"
        ),
    },
  ];

  return (
    <div className="p-6 flex flex-col gap-4">
      <BreadcrumbComponent items={breadcrumbItems} />
      <Table
        dataSource={transactions || []}
        columns={columns}
        rowKey="buyItemId"
        scroll={{ x: "max-content" }}
        className="shadow-md w-full overflow-auto"
      />
    </div>
  );
};

export default Transactions;
